import {
  UsPrincipalAdCvdCase,
  AdCvdCaseStatus,
} from '@xbcb/api-gateway-client';
import { UsPrincipalAdCvdCaseStatus } from '@xbcb/trade-data-types';

export enum UsPrincipalAdCvdCaseType {
  AD = 'AD',
  CV = 'CV',
}

export interface UsPrincipalAdCvdCaseFilterCriteria {
  principalCaseStatus?: UsPrincipalAdCvdCaseStatus;
  caseStatus?: AdCvdCaseStatus;
  countryCode?: string;
  caseType?: UsPrincipalAdCvdCaseType;
}

export const filterUsPrincipalAdCvdCases = (
  cases: UsPrincipalAdCvdCase[],
  filterCriteria: UsPrincipalAdCvdCaseFilterCriteria,
) => {
  const {
    principalCaseStatus: targetPrincipalCaseStatus,
    caseStatus: targetCaseStatus,
    countryCode: targetCountryCode,
    caseType: targetCaseType,
  } = filterCriteria;
  const targetCasePrefix = !targetCaseType
    ? undefined
    : targetCaseType === UsPrincipalAdCvdCaseType.AD
    ? 'A'
    : 'C';
  return cases
    .filter(
      ({ status, countryCode, principalCaseNumber }) =>
        (!targetPrincipalCaseStatus || status === targetPrincipalCaseStatus) &&
        (!targetCountryCode || countryCode === targetCountryCode) &&
        (!targetCasePrefix || principalCaseNumber.startsWith(targetCasePrefix)),
    )
    .map((principalCase) => {
      return {
        ...principalCase,
        adCvdCases: principalCase.adCvdCases?.filter(
          ({ status }) => !targetCaseStatus || status === targetCaseStatus,
        ),
      };
    });
};
